export default {
  sendMessageTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_send_message',
    defaultMessage: 'Send message',
  },
  uploadReceiptTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_upload_receipt',
    defaultMessage: 'Upload receipt',
  },
  repairReplaceTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_repair_replace',
    defaultMessage: 'Repair/replace',
  },
  repairTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_repair',
    defaultMessage: 'Repair',
  },
  replaceTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_replace',
    defaultMessage: 'Replace',
  },
  refundTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_refund',
    defaultMessage: 'Refund',
  },
  returnToCustomerTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_return_to_customer',
    defaultMessage: 'Return to customer',
  },
  repairReplaceRefundTaskType: {
    id: 'bo_sellers_customer_care_table_column_task_repair_replace_refund',
    defaultMessage: 'Repair/replace/refund',
  },
}
